export default __webpack_public_path__ + "static/media/loaderSmall.e59860a9.gif";